import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Col, Grid, Row} from "react-bootstrap";
import { Link } from "react-router-dom";
import Button from "components/CustomButton/CustomButton.jsx";
import NomCommercialForm from './NomCommercialForm';

class NomCommercialResult extends React.Component {

    constructor(props) {
        super(props);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            vProductNom: '',
            vProductNom1: '',
            vNom: '',
            nomProduct: '',
            result: {
                status:null,
                data:"Après avoir selectionner vos données appuyer sur le button ci-dessous pour lancer l'analyse "
            }
        }
    }
    onChangeProduct1 = product => {
        this.state.vNom = product.label;
        if(product.nomCommercialContreIndique1== undefined){
            product.nomCommercialContreIndique1 =''
        }
        if(product.nomCommercialContreIndique1.includes('$')){
            this.state.vProductNom1 = product.nomCommercialContreIndique1.split("$");
            this.state.vNom = product.label.toLowerCase();
        }
        else{
            this.state.vProductNom1 = product.nomCommercialContreIndique1;
            this.state.vNom = product.label.toLowerCase();
        }

    }

    onChangeProduct = product => {
        this.state.nomProduct = product.label;
        if(product.nomCommercialContreIndique== undefined){
            product.nomCommercialContreIndique =''
        }
        if(product.nomCommercialContreIndique.includes('$')){
            this.state.vProductNom = product.nomCommercialContreIndique.split("$");
            this.state.nomProduct = product.label.toLowerCase();
        }
        else{
            this.state.vProductNom = product.nomCommercialContreIndique;
            this.state.nomProduct = product.label.toLowerCase();
        }
        }
        
    onSubmit(event) {
        event.preventDefault();
        if(this.state.nomProduct==''||this.state.vNom == ''){
            this.setState({result: {status:0, data:"VEUILLEZ SELECTIONNER LES DONNEES A ANALYSER !"}});
            this.props.showNotification("Champ vide !", "danger");
        }
        else if(this.state.vProductNom.indexOf(this.state.vNom) != -1 || this.state.vProductNom1.indexOf(this.state.nomProduct) != -1){
            this.setState({result: {status:1, data:"< "+this.state.nomProduct.toUpperCase()+" > "+" est contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >"}});
            this.props.showNotification("< "+this.state.nomProduct.toUpperCase()+" > "+" est contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >", "warning");
        } else{
            this.setState({result: {status:-1, data:"< "+this.state.nomProduct.toUpperCase()+" > "+" n'est pas contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >"}});
            this.props.showNotification("< "+this.state.nomProduct.toUpperCase()+" > "+" n'est pas contre-indiqué en association avec le produit : "+"< "+this.state.vNom.toUpperCase()+" >", "success");
        }  
       
    }
    
    render() {
        return (
            <div className="main-content" >
                <Grid fluid>
                <Row>
                    <Col md={12} style={{ marginBottom: "16px" }}>
                        <Link to="/app/analyse/analyses">
                            <Button bsStyle="default" fill bsSize="lg">
                                Retour
                            </Button>
                        </Link>
                    </Col>
                </Row>
                    <Col sm={12}>
                        <form onSubmit={this.onSubmit}>
                            <NomCommercialForm
                                onChangeProduct1 = {this.onChangeProduct1}
                                onChangeProduct = {this.onChangeProduct}
                                result={this.state.result}
                            />
                        </form>
                    </Col>
                </Grid>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        message: state.status.message,
        loading: state.status.loading,
        substance: state.substances.substance,        
    }
};
  
NomCommercialResult.propTypes = {
    match: PropTypes.object,
    message: PropTypes.object,
    loading: PropTypes.bool,
    showNotification: PropTypes.func,
};

export default connect(mapStateToProps)(NomCommercialResult);